import { CLEAR_SITE_DATA } from '../application';
import { DELETE_FILE_SUCCESS } from '../files';
import { PIN_FILE, REMOVE_PINNED_FILE } from './actions';

const initialState = {
  pinnedFiles: [],
};

export function reducer(state = structuredClone(initialState), action) {
  switch (action.type) {
    case PIN_FILE: {
      const { fileId } = action;
      if (state.pinnedFiles.includes(fileId)) return state;

      return {
        ...state,
        pinnedFiles: [...state.pinnedFiles, fileId],
      };
    }
    case REMOVE_PINNED_FILE:
    case DELETE_FILE_SUCCESS: {
      const { fileId } = action;

      return {
        ...state,
        pinnedFiles: state.pinnedFiles.filter((id) => id !== fileId),
      };
    }
    case CLEAR_SITE_DATA: {
      return structuredClone(initialState);
    }
    default: {
      return state;
    }
  }
}
